import { render, staticRenderFns } from "./entityFieldCustomCombo.vue?vue&type=template&id=15c38ce0"
import script from "./entityFieldCustomCombo.vue?vue&type=script&lang=js"
export * from "./entityFieldCustomCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports